/* Piave x Domina Influência — captura de indicação de afiliado (?ref) e cupom (?cupom) */
(function () {
  try {
    var qs = new URLSearchParams(location.search);
    var ref = qs.get('ref') || qs.get('aff');
    var coupon = qs.get('cupom') || qs.get('coupon') || qs.get('discount');
    var DAYS = 30;

    function setCookie(name, val) {
      var d = new Date(); d.setTime(d.getTime() + DAYS * 864e5);
      document.cookie = name + '=' + encodeURIComponent(val) + ';expires=' + d.toUTCString() + ';path=/;SameSite=Lax';
    }

    // 1) persiste o ref do afiliado: cookie (espelha o domina_ref) + atributo do carrinho p/ reconciliação
    if (ref) {
      setCookie('domina_ref', ref);
      try { localStorage.setItem('domina_ref', ref); } catch (e) {}
      fetch('/cart/update.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ attributes: { domina_ref: ref } })
      }).catch(function () {});
    }

    // 2) cupom do afiliado: aplica o desconto nativo do Shopify uma única vez e limpa a URL
    if (coupon && !sessionStorage.getItem('domina_disc')) {
      sessionStorage.setItem('domina_disc', coupon);
      qs.delete('cupom'); qs.delete('coupon'); qs.delete('discount');
      var rest = qs.toString();
      var redirect = location.pathname + (rest ? '?' + rest : '');
      location.replace('/discount/' + encodeURIComponent(coupon) + '?redirect=' + encodeURIComponent(redirect));
    }
  } catch (e) {}
})();
